import { inject, Injectable } from '@angular/core';
import { AppInitializerCustomBaseService } from '@polygon/core';
import { ValuekeepEvents } from './valuekeep-events';

@Injectable()
export class CustomInitService extends AppInitializerCustomBaseService {
	private readonly valuekeepEvents = inject(ValuekeepEvents);

	override async initialize(): Promise<void> {
		this.valuekeepEvents.initialize();
	}
}
